import { render, staticRenderFns } from "./OrderDetailV2.vue?vue&type=template&id=c6de8276&scoped=true"
import script from "./OrderDetailV2.vue?vue&type=script&lang=js"
export * from "./OrderDetailV2.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailV2.vue?vue&type=style&index=0&id=c6de8276&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6de8276",
  null
  
)

export default component.exports